/** Human summary of a webhook endpoint's event subscription, used as the
 *  card subtitle in the webhooks settings list. `["*"]` becomes "All events";
 *  otherwise just a count. */
export function summarizeEvents(events: string[]): string {
  if (events.includes("*")) return "All events";
  if (events.length === 1) return "1 event";
  return `${events.length} events`;
}
